import { z } from 'zod';
export const deliveryMethodSchema = z.enum(['Both', 'Email', 'Mail']);
export const DEFAULT_DELIVERY = 'Both';
export function parseStoredDelivery(value) {
    if (typeof value !== 'string')
        return undefined;
    const wanted = value.trim().toLowerCase();
    if (wanted === '')
        return undefined;
    return deliveryMethodSchema.options.find((method) => method.toLowerCase() === wanted) ?? 'Mail';
}
export function resolveDelivery(saved, hasEmail) {
    if (!hasEmail)
        return { method: 'Mail', why: 'no_email' };
    if (saved === undefined)
        return { method: DEFAULT_DELIVERY, why: 'default' };
    return { method: saved, why: 'saved' };
}
//# sourceMappingURL=customerDelivery.js.map